"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSaveAsDialog = exports.useSaveAsDialogProps = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var useSaveAs_1 = require("./useSaveAs");
var SaveAsDialogRenderer_1 = require("./SaveAsDialogRenderer");
var locales_1 = require("../../../locales");
var model_1 = require("../../../model");
/**
 * @internal
 */
function useSaveAsDialogProps() {
    var _a = sdk_ui_kit_1.useToastMessage(), addSuccess = _a.addSuccess, addError = _a.addError;
    var dispatch = model_1.useDashboardDispatch();
    var closeSaveAsDialog = react_1.useCallback(function () { return dispatch(model_1.uiActions.closeSaveAsDialog()); }, [dispatch]);
    var isSaveAsDialogOpen = model_1.useDashboardSelector(model_1.selectIsSaveAsDialogOpen);
    var onSaveAsError = react_1.useCallback(function () {
        closeSaveAsDialog();
        addError(locales_1.messages.messagesDashboardSaveFailed);
    }, [closeSaveAsDialog, addError]);
    var onSaveAsSuccess = react_1.useCallback(function () {
        closeSaveAsDialog();
        addSuccess(locales_1.messages.messagesDashboardSaveSuccess);
    }, [closeSaveAsDialog, addSuccess]);
    var onSaveAsCancel = react_1.useCallback(function () {
        closeSaveAsDialog();
    }, [closeSaveAsDialog]);
    return {
        isVisible: isSaveAsDialogOpen,
        onCancel: onSaveAsCancel,
        onError: onSaveAsError,
        onSuccess: onSaveAsSuccess,
    };
}
exports.useSaveAsDialogProps = useSaveAsDialogProps;
/**
 * @alpha
 */
exports.DefaultSaveAsDialog = function (props) {
    var onSubmit = props.onSubmit, onCancel = props.onCancel, onError = props.onError, isVisible = props.isVisible, onSuccess = props.onSuccess;
    var _a = useSaveAs_1.useSaveAs({ onSubmit: onSubmit, onSubmitSuccess: onSuccess, onSubmitError: onError }), locale = _a.locale, dashboardTitle = _a.dashboardTitle, isKpiWidgetEnabled = _a.isKpiWidgetEnabled, isScheduleEmailsEnabled = _a.isScheduleEmailsEnabled, isDashboardSaving = _a.isDashboardSaving, isDashboardLoaded = _a.isDashboardLoaded, handleSaveAs = _a.handleSaveAs, isInEditMode = _a.isInEditMode;
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement(SaveAsDialogRenderer_1.SaveAsDialogRenderer, { locale: locale, dashboardTitle: dashboardTitle, isKpiWidgetEnabled: isKpiWidgetEnabled, isDashboardLoaded: isDashboardLoaded, isDashboardSaving: isDashboardSaving, isScheduleEmailsEnabled: isScheduleEmailsEnabled, isInEditMode: isInEditMode, onSubmit: handleSaveAs, onCancel: onCancel }));
};
//# sourceMappingURL=index.js.map